/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStocktakeActiveCtrl
 */
angular.module('mercury.modules.stock.stocktake')
.controller('StockStocktakeActiveCtrl', ["dialog", "$scope", "$state", "$stateParams", "Stocktakes", "title", function(dialog, $scope, $state, $stateParams, Stocktakes, title) {
  title.set('Outstanding Stocktakes');

  $scope.stocktakes = Stocktakes.getAllActive();

  $scope.stocktakes.$promise.then(function() {
    if ($stateParams.templateId || $stateParams.itemSuperGroupId) {
      var creationParams = angular.copy($stateParams);

      //Clear the stateParams so reloading the page won't create a stocktake again.
      $state.go('.', {templateId: null, itemSuperGroupId: null}, {reload: false, location: 'replace'});

      $scope.creatingStocktake = true;
      Stocktakes.create(creationParams)
      .then(function(result) {
        $scope.creatingStocktake = false;

        $scope.stocktakes.push(result);
      }, function() {
        $scope.creatingStocktake = false;
      });
    }
  });
}]);
